import { Ref } from 'react';
import { ChatMessage } from './ChatMessage';
import { ChatMessage as ChatMessageType } from '../types/askStanley.types';

interface MessageListProps {
    messages: ChatMessageType[];
    onPreviewImage: (file: File) => void;
    onScroll?: () => void;
}

export const MessageList = ({
    messages,
    onPreviewImage,
    onScroll,
    ref,
}: MessageListProps & { ref?: Ref<HTMLDivElement> }) => {
    return (
        <div ref={ref} onScroll={onScroll} className='flex-1 space-y-6 overflow-y-auto p-4'>
            {messages.length === 0 ? (
                <div className='flex h-full flex-col items-center justify-center text-center'>
                    {/* Empty state - no messages yet */}
                </div>
            ) : (
                messages.map(message => (
                    <ChatMessage key={message.id} message={message} onPreviewImage={onPreviewImage} />
                ))
            )}
        </div>
    );
};

MessageList.displayName = 'MessageList';
